import { Clock3, History, UserRoundCheck, X } from "lucide-react";
import { UserKpiCard } from "@/pages/users/components/UserKpiCard";
import type { RequestStats } from "../commissionEditQueue-calculations";

export function CommissionEditQueueStatsGrid({ stats }: { stats: RequestStats }) {
  return (
    <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <UserKpiCard
        label="Total demandes"
        value={String(stats.total)}
        detail={`${stats.pending} en attente`}
        icon={History}
        tone="gold"
      />
      <UserKpiCard
        label="À traiter"
        value={String(stats.pending)}
        detail="Demandes sans décision"
        icon={Clock3}
        tone={stats.pending > 0 ? "danger" : "neutral"}
      />
      <UserKpiCard
        label="Approuvées"
        value={String(stats.approved)}
        detail="Corrections appliquées"
        icon={UserRoundCheck}
        tone="success"
      />
      <UserKpiCard
        label="Refusées"
        value={String(stats.rejected)}
        detail="Demandes conservées en historique"
        icon={X}
        tone={stats.rejected > 0 ? "danger" : "neutral"}
      />
    </div>
  );
}
